<template>
<div>
  <v-card id="card-page-type">
    <v-container>
      <v-row class="nonothing">
        <v-col cols="12" outlined id="card-unselected-projects-table">
          <h3>
            Selecione os projetos que farão parte da votação:
            <b class="requiredfield">*</b>
          </h3>
          <v-component v-if="unselectedProjectTable" :is="unselectedProjectTable"
            type="ACTION_TABLE"
            :projects="pollUnselectedProjects"
            :tags="tags"
            action="add"
            @triggerAction="onAdd"
            btnText="Adicionar projetos selecionados"
            @btnClicked="onAdd"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-card>

  <v-card id="card-page-type">
    <v-container>
      <v-row class="nonothing">
        <v-col cols="12" outlined id="card-selected-projects-table">
          <h3>
            Projetos já selecionados:
            <b class="requiredfield">*</b>
          </h3>
          <v-component v-if="selectedProjectTable" :is="selectedProjectTable"
            type="ACTION_TABLE"
            :projects="pollSelectedProjects"
            :tags="tags"
            action="remove"
            @triggerAction="onRemove"
            btnText="Remover projetos selecionados"
            @btnClicked="onRemove"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
  </div>
</template>


<script>
import opportunityTable from '@/components/project/OpportunityProjectTable';
import monitorTable from '@/components/project/MonitorProjectTable';

import { mapState, mapActions } from 'vuex';

export default {
  name: 'ManageProjectsFormField',
  props: [
    'source',
    'tags'
  ],
  data: () => ({
  }),
  computed: {
    unselectedProjectTable: function() {
      return this.source === 'OPPORTUNITY' ? opportunityTable : monitorTable
    },
    selectedProjectTable: function() {
      return this.source === 'OPPORTUNITY' ? opportunityTable : monitorTable
    },
    pollUnselectedProjects: {
      get() {
        return this.$store.state.pollUnselectedProjects },
      set( projects ) { this.$store.commit( 'setUnselectedProjects', projects ) }
    },
    pollSelectedProjects: {
      get() { return this.$store.state.pollSelectedProjects },
      set( projects ) { this.$store.commit( 'setSelectedProjects', projects ) }
    },
    listOfSelectedProjects: {
      get() { return this.$store.state.poll.project.listOfSelectedProjects },
      set( projectIds ) { this.$store.commit( 'updateSelectedProjectsInput', projectIds ) }
    }
  },
  methods: {
    onAdd( toAddProjectIds ) {
      if( !Array.isArray( toAddProjectIds ) )
        throw Error( 'projectsIds must be an Array' );

      this.listOfSelectedProjects = toAddProjectIds.concat( this.listOfSelectedProjects );
      let leftUnselectedProjects = [];
      let newSelectedProjects = this.pollSelectedProjects;

      this.pollUnselectedProjects.filter( (project) => {
        this.listOfSelectedProjects.includes(project.id)
          ? newSelectedProjects.push( project )
          : leftUnselectedProjects.push( project )
      })

      this.pollUnselectedProjects = leftUnselectedProjects;
      this.pollSelectedProjects = newSelectedProjects;
    },
    onRemove( toRemoveProjectIds ) {
      if( !Array.isArray( toRemoveProjectIds ) )
        throw Error( 'projectsIds must be an Array' );

      this.listOfSelectedProjects
        = this.listOfSelectedProjects.filter(
          projectId => !toRemoveProjectIds.includes( projectId )
        );

      let newUnselectedProjects = this.pollUnselectedProjects;
      let leftSelectedProjects = [];
      this.pollSelectedProjects.filter( (project) => {
        this.listOfSelectedProjects.includes(project.id)
          ? leftSelectedProjects.push( project )
          : newUnselectedProjects.push( project )
      })

      this.pollSelectedProjects = leftSelectedProjects;
      this.pollUnselectedProjects = newUnselectedProjects
    }
  }
}
</script>


<style lang="scss" scoped>
.nonothing {
  margin: 0 !important;
  padding: 0 !important;
}

// FORMSPAGE
#card-page-type {
  background: #fcfcfc !important;
  border: thin solid #d3d3d3;
  border-left: 3px solid #2d9fab;
  box-shadow: none !important;
  margin: 0 0 24px !important;
  padding: 8px !important;
  display: grid;
  border-radius: 0 !important;

  h3 {
    color: #242424;
    font-family: 'Source Sans Pro', sans-serif;
    margin: 0 0 10px;
    font-size: 18px;
    line-height: 22px;
    font-weight: normal;
    opacity: 0.9;

    .requiredfield {
      color: #2e9fac;
      font-size: 22px;
      line-height: 14px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/form/formField/project/ManageProjectsFormField.vue